import React from 'react';
import PropTypes from 'prop-types';
import {ParallaxLayer} from '../../';
import root from 'window-or-global';

export default class ScreenshotSection extends React.Component {
    static propTypes = {
        screenshots: PropTypes.array,
        active: PropTypes.bool,
        footerActive: PropTypes.bool,
        height: PropTypes.number,
        width: PropTypes.number,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        activeSlide: PropTypes.number,
        rebuildDirty: PropTypes.bool,
        title: PropTypes.string,
        description: PropTypes.string
    };

    //https://github.com/wagerfield/parallax
    parallax = {};

    disabled = false;

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            this.disabled = false;
            const {parallax, id} = this.getCurrentSlide(nextProps);
            if (parallax) {
                parallax.enable();
                parallax.updateDimensions();
                if (process.env.NODE_ENV !== 'production') {
                    console.debug('parallax loc enable', id);
                }
            } else {
                this.setupParallax(id);
            }
            if (id) {
                for (const key in this.parallax) {
                    if (key && typeof key === 'string') {
                        const p = this.parallax[key];
                        if (key !== id && p && p.disable) {
                            p.disable();
                            if (process.env.NODE_ENV !== 'production') {
                                console.debug('parallax loc disable', key);
                            }
                        }
                    }
                }
            }

            if (this.props.rebuildDirty !== nextProps.rebuildDirty) {
                this.handleResize();
            }
        } else if (!this.disabled) {
            for (const key in this.parallax) {
                if (key && typeof key === 'string') {
                    const p = this.parallax[key];
                    if (p && p.disable) {
                        p.disable();
                        if (process.env.NODE_ENV !== 'production') {
                            console.debug('parallax loc disable', key);
                        }
                    }
                }
            }
            this.disabled = true;
        }
    }

    componentDidMount() {
        if (this.props.active || this.props.footerActive) {
            const screenshot = this.props.screenshots[0] || {};
            this.setupParallax(screenshot.key);
        }
    }

    getCurrentSlide = (props) => {
        const screenshot = props.screenshots[props.activeSlide] || {};
        const id = screenshot.key || null;
        const parallax = this.parallax[id] || null;
        return {id, parallax};
    };

    handleResize = () => {
        if (!Object.keys(this.parallax).length) return;

        const {parallax} = this.getCurrentSlide(this.props);
        if (parallax) {
            parallax.updateDimensions();
            if (process.env.NODE_ENV !== 'production') {
                console.debug('parallax loc updateDimensions');
            }
        }
    };

    setupParallax = (id) => {
        if (!id) return;

        if (process.env.NODE_ENV !== 'production') {
            console.debug('setupParallax', id);
        }

        const scene = document.getElementById(id);

        if (!this.parallax[id]) {
            const scalarX = this.props.mobile ? 10 : 15;
            const scalarY = this.props.mobile ? 10 : 15;

            this.parallax[id] = new Parallax(scene, {
                limitY: 160,
                limitX: false,
                scalarX,
                scalarY,
                frictionX: 0.2,
                frictionY: 0.4
            });

            //bc it gets intialized disabled it hits a bug in parallex which doesn't start the device orientation listener without this hack
            if (this.props.mobile || this.props.tablet) {
                this.parallax[id].orientationStatus = 1;
            }
        }
    };

    nextSlide = () => {
        $.fn.fullpage.moveSlideRight();
    };

    prevSlide = () => {
        $.fn.fullpage.moveSlideLeft();
    };

    imagesRendered = {};

    render() {
        const active = this.props.active || this.props.footerActive;
        const contentStyle = this.props.active ? 'content active' : 'content';
        const screenshots = this.props.screenshots || [];

        return (
            <div id="screenshotSection" className="section">
                {
                    screenshots.map((screenshot, i) => {
                        if (!screenshot.key) {
                            console.warn('invalid screenshot data!');
                            return (<div />);
                        }
                        let img;
                        if (!root.__server_side_render && ((active && this.props.activeSlide === i) || this.imagesRendered[i])) {
                            this.imagesRendered[i] = true;
                            img = screenshot.image.desktopImage;
                            if (this.props.mobile) {
                                img = screenshot.image.tabletImage;
                            }
                        }
                        const style = {};
                        if (img) {
                            const url = `url("${img}")`;
                            style.backgroundImage = url;
                        }

                        return (
                            <div className="slide" key={`screenshot-${screenshot.key}`}>
                                <div id={screenshot.key} className="parallax-scene">
                                    <ParallaxLayer depth={1} height={this.props.height} width={this.props.width}>
                                        <div style={style} className="background" />
                                    </ParallaxLayer>
                                </div>
                            </div>
                        );
                    })
                }
                <div className={contentStyle}>
                    <h1>{this.props.title}</h1>
                    <p>{this.props.description}</p>
                </div>

                <div className={`slide-navigation ${this.props.active ? 'active' : ''}`}>
                    <i role="presentation" className="icon-prevArrow" onClick={this.prevSlide} />
                    <i role="presentation" className="icon-nextArrow" onClick={this.nextSlide} />
                </div>
            </div>
        );
    }
}
